import { MobileOnlyOptions } from "./MobileOnlyOptions";
import { USALandingOptions } from "./USALandingOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate11: LandingPageConfigOptions = {
  ...MobileOnlyOptions,
  ...USALandingOptions,
};
